import React, { useState, useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { globalAlert, globalLoader } from "../../actions/commonActions";
import InputComponent from "../_common/inputComponent";
import { useTranslation } from "react-i18next";

const AddEditEducationModal = (props) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState("");
  const [titleErr, setTitleErr] = useState(false);
  const [author, setAuthor] = useState("");
  const [file, setFile] = useState(null);
  const [fileErr, setFileErr] = useState(false);
  const [fileLink, setFileLink] = useState("");
  const [fileLinkErr, setFileLinkErr] = useState("");
  const [linkOrFile, setLinkOrFile] = useState("file");
  const [sendNotification, setSendNotification] = useState(false);
  const [filePreview, setFilePreview] = useState(null)
  const [filePreviewErr, setFilePreviewErr] = useState(false);
  const [filePreviewSrc, setFilePreviewSrc] = useState(null)


  useEffect(() => {
    setPropsToState(); // eslint-disable-next-line
  }, [props?.data]);

  const setPropsToState = () => {
    // setVideoTitle(props?.data?.videoTitle);
    // setVideoDescription(props?.data?.videoDescription);
    // setFile(props?.data?.file);
  };

  const handleValidation = () => {
    let flag = true;
    if (!title) {
      setTitleErr(true);
      flag = false;
    }
    if (props.type === 'video' && !filePreview) {
      setFilePreviewErr(true)
      flag = false;
    }

    if (linkOrFile === "file" && !file) {
      setFileErr(true);
      flag = false;
    }
    else if (linkOrFile === "link" && !fileLink) {
      setFileLinkErr(true);
      flag = false;
    }
    return flag;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (await handleValidation()) {
      globalLoader(true);
      let formData = new FormData();
      if (props?.type === "video") {
        formData.append("videoTitle", title);
        formData.append("videoAuthor", author);
        linkOrFile === "file"
          ? formData.append("videoFile", file)
          : formData.append("videoUrl", fileLink);
        formData.append("filePreview", filePreview);

      } else {
        formData.append("documentTitle", title);
        formData.append("file", file);
      }
      formData.append("notifyUsers", sendNotification);
      props.closeModal(formData);
    }
  };

  const setFileFunc = (ev) => {
    if (props?.type === "video") {
      if (
        ev?.target?.files[0]?.type === "video/mp4" ||
        ev?.target?.files[0]?.type === "video/x-m4v"
      ) {
        const file = ev.target.files[0];
        setFile(file);
      } else {
        globalAlert("error", t("admin.addEditEducation.onlyMp4Allowed"));
      }
    } else {
      if (ev?.target?.files[0]?.type === "application/pdf") {
        const file = ev.target.files[0];
        setFile(file);
      } else {
        globalAlert("error", t("admin.addEditEducation.onlyPdfAllowed"));
      }
    }
  };

  const setFilePreviewFunc = (ev) => {
    const file = ev.target.files[0];
    if (file) {
      if (
        file?.type === "image/png" ||
        file?.type === "image/jpeg"
      ) {
        setFilePreviewSrc(URL.createObjectURL(file))
        setFilePreview(file);
      } else {
        globalAlert("error", t("admin.addEditEducation.onlyJpegPngAllowed"));
      }
    }
  }

  return (
    <Modal
      open={props.open}
      onClose={() => props.closeModal()}
      center
      classNames={{ modal: "admin-modal modal-own" }}
    >
      <div>
        <p className="admin-banner">
          {t(props?.edit ? "admin.addEditEducation.editTitle" : "admin.addEditEducation.addTitle")}{" "}
          <span className="text-capitalize">{props?.type}</span>
        </p>
      </div>

      {props?.type === "video" && (<div className="tab-own-wrapper text-center">

        <ul className="tab-wrapper-list d-inline-flex flex-wrap list-unstyled">
          <li
            className={`${linkOrFile === "file" ? "active" : ""}`}
            onClick={() =>
              setLinkOrFile("file")
            }
          >
            {t("admin.addEditEducation.uploadFileTab")}
          </li>
          <li
            className={`${linkOrFile === "link" ? "active" : ""}`}
            onClick={() =>
              setLinkOrFile("link")
            }
          >
            {t("admin.addEditEducation.provideLinkTab")}
          </li>
        </ul>
      </div>
      )}
      <form onSubmit={handleSubmit} className="form-own px-3">
        <div className="row px-2">
          <div className="col-12 px-2">
            <div className="form-own-group">
              <InputComponent
                placeholder={t("admin.addEditEducation.titlePlaceholder")}
                label={
                  <>
                    {t("admin.addEditEducation.titleLabel")} <span className="color-red">*</span>
                  </>
                }
                type="text"
                name="videoTitle"
                theme="white"
                value={title}
                handleCallback={(val) => {
                  setTitle(val);
                }}
              />
              <div className="error-text">
                {!title && titleErr && (
                  <span>{t("admin.addEditEducation.titleRequired")}</span>
                )}
              </div>
            </div>
          </div>

          {linkOrFile === "file" ? (
            <div className="col-12 px-2">
              <div className="form-own-group">
                <label className="form-own-label">
                  {t("admin.addEditEducation.uploadFileLabel")} <small>{
                      props?.type === "video"
                        ? `(${t("admin.addEditEducation.onlyMp4Allowed")})`
                        : `(${t("admin.addEditEducation.onlyPdfAllowed")})`
                    }</small> <span className="color-red">*</span>
                </label>
                <div className="upload-btn upload-btn-dashed" id="previewLogo">
                  {file && file.name && (
                    <div className="show-icon-wrapper pb-2 mb-1">
                      {file.name}
                    </div>
                  )}

                  <div className="upload-btn-txt btn ">
                    {file ? t("admin.addEditEducation.changeFile") : t("admin.addEditEducation.addFile")}
                  </div>
                  <input
                    type="file"
                    accept={
                      props?.type === "video"
                        ? "video/mp4,video/x-m4v"
                        : "application/pdf"
                    }
                    className="upload-input cursor"
                    onChange={setFileFunc}
                  />
                </div>
                <div className="error-text">
                  {!file && fileErr && <span>{t("admin.addEditEducation.fileRequired")}</span>}
                </div>
              </div>
            </div>
          ) : (
            <div className="col-12 px-2">
              <div className="form-own-group">
                <InputComponent
                  placeholder={t("admin.addEditEducation.linkPlaceholder")}
                  label={
                    <>
                      {t("admin.addEditEducation.linkLabel")} <span className="color-red">*</span>
                    </>
                  }
                  type="text"
                  name="videoTitle"
                  theme="white"
                  value={fileLink}
                  handleCallback={(val) => {
                    setFileLink(val);
                  }}
                />
                <div className="error-text">
                  {!fileLink && fileLinkErr && (
                    <span>{t("admin.addEditEducation.linkRequired")}</span>
                  )}
                </div>
              </div>
            </div>
          )}
          {props?.type === "video" && (
            <div className="col-12 px-2 pt-3">
              <div className="form-own-group">
                <label className="form-own-label">
                  {t("admin.addEditEducation.thumbnailLabel")} <small>({t("admin.addEditEducation.thumbnailFormats")})</small> <span className="color-red">*</span>
                </label>
                <div className="upload-btn upload-btn-dashed" id="previewLogo">
                  {filePreview && filePreview.name && (
                    <div className="show-icon-wrapper pb-2 mb-1">
                      {filePreview.name}
                    </div>
                  )}
                  {filePreviewSrc &&
                    <div className="img-preview px-3 py-3">
                      <img src={filePreviewSrc} alt="img" />
                    </div>}
                  <div className="upload-btn-txt btn ">
                    {filePreview ? t("admin.addEditEducation.changeFile") : t("admin.addEditEducation.addFile")}
                  </div>

                  <input
                    type="file"
                    accept={
                      'image/png,image/jpeg'
                    }
                    className="upload-input cursor"
                    onChange={setFilePreviewFunc}
                  />
                </div>
                <div className="error-text">
                  {!filePreview && filePreviewErr && <span>{t("admin.addEditEducation.thumbnailRequired")}</span>}
                </div>
              </div>
            </div>
          )}
          <div className="col-12 px-2">
            <div className="pt-3">
              <input
                type="checkbox"
                name="sendNotification"
                id="sendNotification"
                checked={sendNotification}
                onChange={() => setSendNotification((a) => !a)}
                style={{
                  height:'16px',
                  width:'16px'
                }}
              />
              <label htmlFor="sendNotification" className="form-own-label pl-2 position-relative" style={{top:'-3px'}}>
              {t("admin.addEditEducation.notifyUsers")}
              </label>
            </div>
          </div>
          {/* {props?.type === "video" && (
            <div className="col-12 text-center pt-3">
              <div className="or-wrapper">Or</div>

              <div
                className="link-wrapper cursor color-primary primary-color"
                onClick={() =>
                  setLinkOrFile(linkOrFile === "file" ? "link" : "file")
                }
              >
                {linkOrFile === "file" ? "Provide the link" : "Upload the file"}
              </div>
            </div>
          )} */}
        </div>
        <div className="admin-btn">
          <button
            onClick={() => props.closeModal()}
            className="btn secondary-btn mr-2"
            type="button"
          >
            {t("common.back")}
          </button>
          <button type="submit" className="btn primary-btn ml-2">
            {t("common.submit")}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddEditEducationModal;
